import * as React from 'react';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';
import { DataInclusionControlsProps } from './types';
import { FormattedMessage } from 'react-intl';

export const DataInclusionControls = ({
	selectedCompanyId,
	includeTemplate,
	includeFinancialPlan,
	includeBusinessPlan,
	includeCompanyData,
	includeScenario,
	onToggle,
	hasTemplate,
	hasFinancialPlan,
	hasBusinessPlan,
	hasCompanyData,
	hasScenario,
}: DataInclusionControlsProps) => {
	const handleChange = (_: React.MouseEvent<HTMLElement>, newValue: string[]) => {
		// Toggle each value that changed
		const currentValues = [
			...(includeTemplate ? ['template'] : []),
			...(includeFinancialPlan ? ['financialPlan'] : []),
			...(includeBusinessPlan ? ['businessPlan'] : []),
			...(includeCompanyData ? ['company'] : []),
			...(includeScenario ? ['scenario'] : []),
		];

		// Find which value was toggled
		const toggledValue = newValue.find(v => !currentValues.includes(v)) || currentValues.find(v => !newValue.includes(v));

		if (toggledValue) {
			onToggle(toggledValue as 'financialPlan' | 'businessPlan' | 'company' | 'scenario' | 'template');
		}
	};

	return (
		<ToggleButtonGroup
			value={[
				...(includeTemplate ? ['template'] : []),
				...(includeFinancialPlan ? ['financialPlan'] : []),
				...(includeBusinessPlan ? ['businessPlan'] : []),
				...(includeCompanyData ? ['company'] : []),
				...(includeScenario ? ['scenario'] : []),
			]}
			onChange={handleChange}
			aria-label='data inclusion'
			size='small'
			sx={{
				'& .MuiToggleButton-root': {
					fontSize: '1rem',
					px: 1.5,
					color: 'primary.main',
					'&.Mui-selected': {
						backgroundColor: 'primary.main',
						color: 'white',
						'&:hover': {
							backgroundColor: 'primary.dark',
						},
					},
					'&.Mui-disabled': {
						color: 'text.disabled',
					},
				},
			}}
		>
			<ToggleButton value='template' aria-label='include template' disabled={!hasTemplate}>
				<FormattedMessage id='data.template' />
			</ToggleButton>
			<ToggleButton value='company' aria-label='include company data' disabled={!hasCompanyData || !selectedCompanyId}>
				<FormattedMessage id='data.company' />
			</ToggleButton>
			<ToggleButton value='financialPlan' aria-label='include financial plan' disabled={!hasFinancialPlan || !selectedCompanyId}>
				<FormattedMessage id='data.financialPlan' />
			</ToggleButton>
			<ToggleButton value='businessPlan' aria-label='include business plan' disabled={!hasBusinessPlan || !selectedCompanyId}>
				<FormattedMessage id='data.businessPlan' />
			</ToggleButton>
			<ToggleButton value='scenario' aria-label='include scenario' disabled={!hasScenario || !selectedCompanyId}>
				<FormattedMessage id='data.scenario' />
			</ToggleButton>
		</ToggleButtonGroup>
	);
};
